import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "grid",
  id: "storeGrid"
}

import Card from "../global/Card.vue";
import WideCard from "../global/WideCard.vue";

import * as StoreManager from "../../firebase/StoreManager";
import { getStoreState } from "@/pinia/stores/StoreState";
import { useRouter } from "vue-router";
import { getState } from "@/pinia/NavigationState";
import { defineComponent } from "vue";
import Store from "@/model/Store";
import { getDistributorManager } from "@/firebase/DistributorManager";
import { getStoreDatabaseState } from "@/pinia/databases/StoreDatabaseState";

const __default__ = defineComponent({
  props: ["stores", "unactives"],

  methods: {
    getDistributorName(store: Store) {
      let distributorManager = getDistributorManager();
      var distributor = distributorManager.getDistributorFromCache(
        store.distributor
      );

      if (distributor) {
        return distributor.name;
      }
      return "Unknown distributor.";
    },
    onStoreClick(store: Store) {
      if (store.database == null) {
        var storeState = getStoreState();
        storeState.set(store);
        getState().navigate("store");
      } else {
        getStoreDatabaseState().set(store);
        getState().navigate("storeDatabase");
      }
    },
  },
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StoreList',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stores, (store) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: store.ref.id
      }, [
        (store.active || _ctx.unactives)
          ? (_openBlock(), _createBlock(WideCard, {
              key: 0,
              click: () => _ctx.onStoreClick(store),
              active: store.active == undefined ? false : store.active,
              obj: store,
              title: store.name,
              redirectPage: "store",
              icon: 
          store.illustration_url == null
            ? 'ico/store.svg'
            : store.illustration_url.get()
        
            }, {
              subtitle: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getDistributorName(store)), 1)
              ]),
              _: 2
            }, 1032, ["click", "active", "obj", "title", "icon"]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})